/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event__content[_ngcontent-%COMP%]{font-size:.789em;color:#626767;line-height:1.36;white-space:pre-wrap}.event__header[_ngcontent-%COMP%]{font-weight:700}.event__new-item[_ngcontent-%COMP%]{padding-top:15px}.event__item-heading[_ngcontent-%COMP%]{font-weight:700}.event-details-row[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;width:100%}.event-details-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:1}"];
export { styles as styles };
